import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Features from './components/Features';
import Download from './components/Download';
import Support from './components/Support';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <About />
      <Features />
      <Download />
      <Support />
      <Contact />
      <Footer />
    </div>
  );
}
